<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea smsLog">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <!-- 搜索框 -->
      <div class="searchBox flex">
        <!-- <el-input placeholder="请输入企业名称" v-model="keyword.complate_name" clearable class="w300"></el-input> -->
        <el-select v-model="keyword.complate_id" multiple collapse-tags placeholder="请选择企业" class="w300">
          <el-option v-for="item in conplateList" :key="item.company_id" :label="item.company_name" :value="item.company_id"></el-option>
        </el-select>
        <el-date-picker
          v-model="keyword.time" 
          type="daterange" 
          range-separator="至" 
          start-placeholder="开始发送时间" 
          end-placeholder="结束发送时间"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button class="searchBtn" type="primary" @click="getSmsLogByCompany()">搜 索</el-button>
      </div>
      <div id="timeEchart" class="logEchart" v-show="allList!=''"></div>
      <div class="noData" v-show="allList==''">暂无数据</div>
    </div>
    
    <!--发送详情-->
    <el-dialog title="发送详情" :visible.sync="sendDio" width="60%">
      <div class="contDio">
        <div class="info">
          <span class="mr30">企业名称：{{send_name}}</span><span class="mr30">短信供应商：{{sms_sup}}</span><span>发送条数：{{send_num}}条</span>
        </div>
        <el-table :data="allSendData[paging.page-1]" style="width:100%">
          <el-table-column type="index" label="序号" width="80px"></el-table-column>
          <el-table-column label="模板名称" prop="template_name"></el-table-column>
          <el-table-column label="内容" prop="content" width="300px"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == '1'" class="col67C">发送成功</span>
              <span v-else class="colF56">发送失败</span>
            </template>
          </el-table-column>
          <el-table-column label="发送时间" prop="send_time"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="paging" v-if="paging.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="paging.page"
            layout="prev, pager, next, jumper"
            :page-count="paging.pageCount">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { templateApi } from "../../../../static/js/api.js"
  import { showToast, deepCopy } from '../../../../static/js/utility/utility';
  export default {
    name: 'smsLog',
    data(){
      return {
        // 分页数据  page为当前页，perPage为每页数量 
        paging: {
          page: 1,
          perPage: 10,
        },
        keyword:{
          complate_id:[],
          time:'',
        },
        conplateList:[],
        pickerOptions:{
          disabledDate(time) {
            // var t = "2019-06-01 00:00:00";  
            // var T = new Date(t);
            return time.getTime() >= new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000) //包括今天 
         }
        },
        
        allList:[],
        cnameList:[],//公司名列表
        successList:[],//成功列表
        errorList:[],//失败列表

        total:16,

        sendDio:false,//发送详情弹窗
        allSendData: [], //分页处理所有发送详情列表
        sendData:[],//发送详情列表
        send_name:'',//企业名称
        sms_sup:'',//供应商
        send_num:0,//发送条数

      }
    },
    components: {
      BreadCrumb
    },
    async created(){
      this.getCompanyList()
      this.getSmsLogByCompany()
    },
    methods:{
      //获取短信发送情况
      async getSmsLogByCompany(){
        let that = this;
        const dataObj = {
          'company_id': that.keyword.complate_id.join(','),
          'start_time': that.keyword.time ? that.keyword.time[0]:'',
          'end_time': that.keyword.time ? that.keyword.time[1]:'',
        }
        const res = await templateApi.getSmsLogByCompany(dataObj)
        if(res.meta.code == 200){
          // console.log(res.data)
          that.allList = res.data
          if(res.data!=''){
            const arr = [],arr2=[],arr3=[];
            for(let i in res.data){
              arr.push(res.data[i].company_name)
              arr2.push(res.data[i].success_count)
              arr3.push(res.data[i].error_count)
            }
            that.total = res.data.length
            that.cnameList = arr
            that.successList = arr2
            that.errorList = arr3
            that.drawLine()
          }
          
        }
      },
      //发送时间分布图
      drawLine(){
        let that = this;
        this.$nextTick(function(){
          // 基于准备好的dom，初始化echarts实例
          let myChart = this.$echarts.init(document.getElementById('timeEchart'))
          // 绘制图表
          let option = {
            title: {
              text: '短信发送条数',
              x:'center',
              padding: [30,0],
              textStyle:{
                fontSize:24,
              }
            },
            legend: { 
              left: '3%',
              top:'50',
              data:['发送成功','发送失败'],
            },
            color: ['#3398DB'],
            tooltip : {
              trigger: 'axis',
              axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '10%',
              top: '100',
              containLabel: true
            },
            xAxis : [
              {
                type : 'category',
                // data : ['公司1', '公司2', '公司3', '公司4', '公司5','公司3', '公司4', '公司5','公司1', '公司2', '公司3', '公司4', '公司5','公司3', '公司4', '公司5',],
                data: that.cnameList,
                axisTick: {
                  alignWithLabel: true
                }
              }
            ],
            yAxis : [
              {
                type : 'value'
              }
            ],
            series : [
              {
                name:'发送成功',
                type:'bar',
                stack:'发送情况',
                barWidth: '50px',
                // data:[10, 52, 200, 334, 390,15, 10, 20,15, 10, 20, 34, 39,15, 10, 20,],
                data: that.successList,
                itemStyle:{
                  normal:{color:"#409EFF"},
                }
              },
              {
                name:'发送失败',
                type:'bar',
                stack:'发送情况',
                barWidth: '50px',
                // data:[15, 10, 20, 34, 39,15, 10, 20,15, 10, 20, 34, 39,15, 10, 20,],
                data: that.errorList,
                itemStyle:{
                  normal:{color:"#F56C6C"},
                }
              }
            ],
            dataZoom: [//给x轴设置滚动条  
              {  
                start:0,
                end: that.total <= 7 ? 100 : (100 - Math.floor(7 / that.total * 100)),  
                type: 'slider',  
                show: true,  
                xAxisIndex: [0],  
                handleSize: 0,//滑动条的 左右2个滑动条的大小  
                height: 8,//组件高度  
                left: 50, //左边的距离  
                right: 40,//右边的距离  
                bottom: 26,//右边的距离  
                handleColor: '#ddd',//h滑动图标的颜色  
                zoomLock:true,
                handleStyle: {  
                    borderColor: "#cacaca",  
                    borderWidth: "1",  
                    shadowBlur: 2,  
                    background: "#ddd",  
                    shadowColor: "#ddd",  
                },
                backgroundColor: '#ddd',//两边未选中的滑动条区域的颜色  
                showDataShadow: false,//是否显示数据阴影 默认auto  
                showDetail: false,//即拖拽时候是否显示详细数值信息 默认true  
                handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',  
                filterMode: 'filter'
              },  
              //下面这个属性是里面拖到  
              {  
                  type: 'inside',  
                  show: true,  
                  xAxisIndex: [0],  
                  start: 0,//默认为1  
                  end: 50
              },  
            ],
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
          myChart.on('click', function (params) {
            // 获取当前公司短信发送情况
            that.getSmsLogDetailsByCompany(params.dataIndex)

          });
        })
      },// 当前页值改变，获取新的客户列表
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
      },
      //获取当前公司短信发送情况
      async getSmsLogDetailsByCompany(index){
        let that = this
        const dataObj = {
          'company_id': that.allList[index].company_id,
        }
        const res = await templateApi.getSmsLogDetailsByCompany(dataObj)
        if(res.meta.code ==200){
          let list = res.data.list
          var allSendData = []
          let perPage = that.paging.perPage
          for(var i=0;i<list.length;i+=perPage){
              allSendData.push(list.slice(i,i+perPage))
          }
          that.paging.pageCount = allSendData.length
          // console.log('allSendData', allSendData)
          that.allSendData = allSendData
          that.sendData = res.data.list
          that.send_name = res.data.company_name
          that.send_num = res.data.count
          that.sms_sup = res.data.channel
          that.sendDio = true
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //获取公司列表
      async getCompanyList(){
        let that = this
        const res = await templateApi.getCompanyList()
        if(res.meta.code ==200){
          that.conplateList = res.data
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
    }
  }
</script>
<style lang="scss">
.smsLog{
  .flex{
    display: flex;
    align-items: center;
  }
  .noData{
    text-align: center;
    color:#999;
    padding: 100px 0;
  }
  .colF56{
    color: #F56C6C
  }
  .col67C{
    color: #67C23A
  }
  .logEchart{
    height: 500px;
  }
  .mr10{
    margin-right: 10px;
  }
  .w300{
    width: 300px;
    margin-right: 10px;
  }
  .searchBtn{
    margin-left: 10px;
  }
  .mr30{
    margin-right: 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Page/TemplateManage/smsLog.vue